import { useContext, useEffect, useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';
import ClaimDetails from './ClaimDetails';
import { makeStyles } from '@material-ui/core/styles';
import { LoginContext } from '../../../contexts/LoginContext';
import LimitedBackdrop from '../../../components/UI/LimitedBackdrop';
import ClaimsAPI from '../../../services/ClaimsAPI';
import { AppContext } from '../../../contexts/AppContext';

const useStyles = makeStyles(theme => ({
  dialog: {
    position: 'absolute',
    width: 1280,
    height: 720,
    top: 0,
  },
  dialogRead: {
    position: 'absolute',
    width: 600,
    height: 720,
    top: 0,
  },
  dialogTitle: {
    position: 'relative',
  },
}));

const ClaimDetailsModal = ({ open, setOpen, claimId, readOnly, reloadGrid }) => {
  const classes = useStyles();
  const { isSupplier } = useContext(LoginContext);
  const { showError, showSuccess, showWarning } = useContext(AppContext);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [newDerivation, setNewDeri] = useState({});
  const [openBackDrop, setOpenBackDrop] = useState(true);
  const [claimData, setClaimData] = useState(null);

  const resetFields = () => {
    setClaimData(null);
  };

  useEffect(() => {
    if (open && claimId) {
      !readOnly && setCurrentTabIndex(2);
      setOpenBackDrop(true);

      ClaimsAPI.getClaimDetails(claimId)
        .then(res => {
          setClaimData(res);
        })
        .catch(error => {
          setOpen(false);
          showError('Error al obtener el detalle del reclamo');
        })
        .finally(() => setOpenBackDrop(false));
    } else {
      setTimeout(() => {
        resetFields();
      }, 500);
    }
  }, [open, claimId]);

  const derive = () => {
    setOpenBackDrop(true);

    ClaimsAPI.deriveClaim(claimId, newDerivation)
      .then(res => {
        reloadGrid();
        showSuccess(`El reclamo se ha ${newDerivation.state ? 'derivado' : 'cerrado'} con éxito`);
      })
      .catch(error => {
        showError(`Error al ${newDerivation.state ? 'derivar' : 'cerrar'} el reclamo`);
      })
      .finally(() => setOpen(false));
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if (newDerivation.state) {
      if ((errors[i++] = newDerivation.observation.isBlank())) {
        errorMessages.push('Debe completar la observación');
      }

      if ((errors[i++] = newDerivation.idArea.isBlank())) {
        errorMessages.push('Debe seleccionar un área a cual derivar el reclamo');
      }
    } else {
      if ((errors[i++] = newDerivation.reply.isBlank())) {
        errorMessages.push('Debe completar la respuesta');
      }
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndDerive = () => validate() && derive();

  return (
    <Dialog  classes={readOnly? {paper: classes.dialogRead}:{paper: classes.dialog} } maxWidth={readOnly?'600':'1280'} open={open} onClose={() => setOpen(false)} aria-labelledby="cusDialogTitle">
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <DialogTitle style={{ position: 'relative' }} id="customized-dialog-title" onClose={() => setOpen(false)}>
        Reclamo {claimData?.id}
      </DialogTitle>
      <DialogContent dividers>
          <ClaimDetails item={claimData} setNewDeri={setNewDeri} readOnly={readOnly}/>
      </DialogContent>
      <DialogActions>
        {readOnly?'':
        <Button onClick={validateAndDerive} color="secondary">
        Derivar
      </Button>}
        <Button onClick={() => {setOpen(false)}} color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClaimDetailsModal;
